import { Reservation, Seat, SeatType } from "@/graphql/types"
import { useCallback, useMemo } from "react"
import styled from "styled-components"

type Props = {
    seat: Seat
    seatTypes: SeatType[]
    reservations: Reservation[]
    size: "small" | "large"
    colorRule?: (seat: Seat) => string | undefined
    onClick: (seat: Seat) => void
    lockRule: (seat: Seat) => boolean
}

const SeatDisplay = (props: Props) => {
    const seatType = useMemo(() => {
        const item = props.seatTypes.find((type) => type.id === props.seat.type)
        return item?.name ?? ""
    }, [props.seat.type, props.seatTypes])

    const guestName = useMemo(() => {
        const item = props.reservations.find((reservation) => reservation.id === props.seat.reservationId)
        return item?.name ?? ""
    }, [props.reservations, props.seat.reservationId])

    const color = useMemo(() => {
        return props.colorRule?.(props.seat) ?? "black"
    }, [props])

    const onClick = useCallback(() => {
        if(props.lockRule(props.seat)) {
            return
        }
        props.onClick(props.seat)
    }, [props])

    return (
        <SeatDisplayStyle>
            <div 
                className={`seat ${props.size} ${props.lockRule(props.seat) ? "locked" : ""}`} 
                style={{backgroundColor: color}}
                onClick={onClick}
            >
                {
                    props.seat.type !== -1 && (
                        <>
                            <p className={`seat-name ${props.size}`}>{props.seat.seatName}</p>
                            { !!guestName && <p className={`guest-name ${props.size}`}>{guestName}</p> }
                            <p className={`seat-type ${props.size}`}>{seatType}</p>
                        </>
                    )
                }
            </div>
        </SeatDisplayStyle>
    )
}

const SeatDisplayStyle = styled.div`
    .seat {
        margin: auto;
        text-align: center;
        font-size: 10px;
        color: white;
        cursor: pointer;
        &.locked {
            background-color: gray;
        }
        &.small {
            width: 40px;
            height: 40px;
        }
        &.large {
            width: 60px;
            height: 60px;
        }
        .seat-type {
            &.small {
                font-size: 12px;
                font-weight: bold;
            }
        }
    }
`

export default SeatDisplay

